// @ts-check

import { PageComponentsRenderer } from "../ComponentRenderer";
import "../jsdoc-types"

/**
 * @param {Object} props
 * @param {ContainerEntry} props.cdaEntry
 * @param {PageEntry} [props.pageCdaEntry]
 */
export function Container({ cdaEntry, pageCdaEntry }) {
	const backgroundColor = cdaEntry.fields.backgroundColor;
	const borderColor = cdaEntry.fields.borderColor;

	return (
		<div className="service-page-container" style={{
			backgroundColor,
			border: borderColor ? `1px solid ${borderColor}` : undefined,
		}}>
			<PageComponentsRenderer cdaEntries={ cdaEntry.fields.content } pageCdaEntry={ pageCdaEntry } />
		</div>
	);
}
